import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import '@amzn/dolphin-uiweb-framework/dist/index.css';
import {HashRouter} from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import "@amzn/meridian-tokens/base/font/amazon-ember.css";
import {getAnalyticsRegion, saveDataForApp} from "./bridge/utils";
import App from "./app";
import {DataHandler, Logger, PUMAMetricHelper, MobileAnalyticsHelper, RedirectHandler} from "@amzn/dolphin-web-framework";
import {getLoggerURL} from "./network/base/base-urls";
import AppDataStore, {APP_DATA_KEYS} from './components/app-data';
import {getPUMACountry, getPUMAEnv, getPUMARegion} from "./network/base/utils";
import {PUMA_APP_ID, PUMA_MODULE_NAME} from "./constants/PUMAConstants";
import {SoundManager} from "./audio/SoundManager";
import LocaleManagerInstance from "./il8n/handler/locale-manager";
import AppError from "./components/app-error";

function playSilentSound() {
    SoundManager.playSilentSound();
    document.removeEventListener('click', playSilentSound);
}

/**
 * Playing a silent sound on first click to capture the user gesture.
 */
document.addEventListener('click', playSilentSound);
saveDataForApp();
DataHandler.parseSearchParams();
RedirectHandler.clearRedirectDataFromURL();
Logger.setLogger(getLoggerURL(), AppDataStore.get(APP_DATA_KEYS.APP_ENV));
PUMAMetricHelper.pumaInit(getPUMACountry(), getPUMARegion(), getPUMAEnv(), PUMA_APP_ID, PUMA_MODULE_NAME);
MobileAnalyticsHelper.initializeAnalytics(getAnalyticsRegion());
document.getElementsByTagName(`html`)[0].setAttribute("dir", LocaleManagerInstance.getDirection());

ReactDOM.render((
    <HashRouter>
        <AppError>
            <App/>
        </AppError>
    </HashRouter>
), document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
    onUpdate: (serviceWorkerRegistration) => {
        const registrationWaiting = serviceWorkerRegistration.waiting;
        if (registrationWaiting) {
            registrationWaiting.postMessage({ type: 'SKIP_WAITING' });
            registrationWaiting.addEventListener('statechange', e => {
                if (e.target.state === 'activated') {
                    window.location.reload();
                }
            });
        }
    }
});